// // Action creators for election types
// export const ELECTIONS_LOADING = 'ELECTIONS_LOADING';
// export const ELECTIONS_SUCCESS = 'ELECTIONS_SUCCESS';
// export const ELECTIONS_ERROR = 'ELECTIONS_ERROR';

// // Fetch all election types
// export const getallElectionTypes = () => async (dispatch) => {
//   dispatch({ type: ELECTIONS_LOADING });
//   try {
//     // Adjust endpoint as needed for your API
//     const res = await fetch('/api/electionTypes');
//     if (!res.ok) throw new Error('Failed to fetch election types');
//     const data = await res.json();
//     dispatch({ type: ELECTIONS_SUCCESS, payload: data });
//     return data;
//   } catch (error) {
//     dispatch({ type: ELECTIONS_ERROR, error: error.message || error });
//     return [];
//   }
// };

// export default getallElectionTypes;
import axios from "axios";
import {
  GETALLELECTIONTYPE,
  CREATEELECTIONTYPE,
 UPDATEELECTIONTYPE,
DELETEELECTIONTYPE,
 
 
  baseURL,
} from "./type";

export const createelectiontype = (data) => (dispatch) => {
  console.log(data, "data");
  var config = {
    method: "post",
     url: baseURL + "/api/setupElectionTypes/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type:   CREATEELECTIONTYPE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getelectiontype = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    // url: baseURL + "setupElectionTypes/getAll",
     url: baseURL + "/api/setupElectionTypes/getAll",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETALLELECTIONTYPE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateelectiontype = (data) => (dispatch) => {
  console.log(data, "data");
  var config = {
    method: "patch",
    url: baseURL + "/api/setupElectionTypes/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type:   UPDATEELECTIONTYPE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteelectiontype = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupElectionTypes/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEELECTIONTYPE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};